export default __webpack_public_path__ + "static/media/breast3.e6f2b92a.jpg";